import { Component, OnInit, inject } from '@angular/core';
import { LifeWizardService } from '../../../life-wizard/life-wizard.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-life-stats',
  templateUrl: './life-stats.component.html',
  styleUrls: ['./life-stats.component.scss'],
  standalone: false,
})
export class LifeStatsComponent implements OnInit {
  private lws = inject(LifeWizardService);
  private router = inject(Router);

  state: string = 'loaded';
  data;

  ngOnInit() {
    this.lws.getLifeStats().subscribe(x => {
      this.data = x;
    });
  }

  goToProfile(ev, id) {
    this.router.navigate([`/li/questionnaire/${id}`]);
  }
}
